import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons';

import { booleanValueToText } from '../utils';
import SectionCard from './SectionCard';

interface EnablementsSectionProps {
  platformFreeTrialEnabled?: boolean;
  ucaasEnabled?: boolean;
  soleProprietorEnabled?: boolean;
  dpaSigned?: boolean;
  migrationSupported?: boolean;
  migrationAutoComplete?: boolean;
}

const Content = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
  row-gap: 12px;
  font-family: Roboto, sans-serif;
`;

const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 270px 1fr;
`;

const Field = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #68737a;
`;

const Value = styled.span`
  font-weight: 800;
  font-size: 14px;
  line-height: 16px;
  color: #68737a;
`;

const EnablementsSection: FunctionComponent<EnablementsSectionProps> = ({
  platformFreeTrialEnabled,
  ucaasEnabled,
  soleProprietorEnabled,
  dpaSigned,
  migrationSupported,
  migrationAutoComplete,
}) => {
  return (
    <SectionCard
      icon={faCheckSquare}
      title="Enablements"
      dataTestId="enablementsSection"
    >
      <Content>
        <ItemWrapper>
          <Field>Platform Free Trial Enabled:</Field>
          <Value data-testid="platformFreeTrialEnabled">
            {booleanValueToText(platformFreeTrialEnabled)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>UCaaS Enabled:</Field>
          <Value data-testid="ucaasEnabled">
            {booleanValueToText(ucaasEnabled)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>Sole Proprietor Enabled:</Field>
          <Value data-testid="soleProprietorEnabled">
            {booleanValueToText(soleProprietorEnabled)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>DPA Signed:</Field>
          <Value data-testid="dpaSigned">{booleanValueToText(dpaSigned)}</Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>CNP Migration Enabled:</Field>
          <Value data-testid="migrationSupported">
            {booleanValueToText(migrationSupported)}
          </Value>
        </ItemWrapper>

        <ItemWrapper>
          <Field>CNP Migration Auto-Complete Enabled:</Field>
          <Value data-testid="migrationAutoComplete">
            {booleanValueToText(migrationAutoComplete)}
          </Value>
        </ItemWrapper>
      </Content>
    </SectionCard>
  );
};

export default EnablementsSection;
